// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ExpandDoubleVector } from './DoubleMatrix';
import { ResVector } from './ResVector';
export class ConstantVector extends ResVector {
    constructor(value, rowNumber, timeShift, priceMult) {
        super(rowNumber, timeShift, priceMult, new ExpandDoubleVector());
        this.FVector = new FreezedVector(0);
        this.FValue = value;
        this.isConstantVector = true;
    }
    get Value() {
        return this.FValue;
    }
    set Value(value) {
        this.FValue = value;
    }
    get RowNumber() {
        return this.FRowNumber;
    }
    // #region IDoubleVector Members
    get(index) {
        return this.FValue;
    }
    set(index, value) { }
}
export class FreezedVector extends ExpandDoubleVector {
    constructor(count) {
        super();
        this.FCount = count || 0;
    }
    Add(value) {
        this.FCount++;
    }
    Clear() {
        this.FCount = 0;
    }
    get Length() {
        return this.FCount;
    }
    set Length(value) {
        this.FCount = value;
    }
    get(index) {
        return 0;
    }
    set(index, value) { }
}
